const moduleMap = {
  "components/collections/util/excel": () => import("../../../components/collections/util/excel.js"),
};

export default function lazyCall(fnName, path) {
  return async (...args) => {
    
    const loadModule = moduleMap[path];
    if (!loadModule)
      throw new Error(`Module not found for path: ${path}`);

    const module = await loadModule();
    return module[fnName](...args);

  };
}